<div class="lum-textarea__wrapper">
  <textarea
    [ngClass]="classes"
    [rows]="rows"
    [required]="required"
    [disabled]="disabled"
    [readonly]="readonly"
    [placeholder]="placeholder"
    [value]="value"
  ></textarea>
  <div *ngIf="hintMessage !== null" [ngClass]="['lum-textarea__hint', hintColor]">
    <small>{{ hintMessage }}</small>
  </div>
</div>
